export enum SkyFlyoutMessageType {
  Open = 0,
  Close = 1
}
